export const appVersion = '0.0.8';
export const appRevision = '67033932596586a4828a38166083e9f7998045dc';



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/environments/version.ts